import { all, takeEvery, put, call } from 'redux-saga/effects'
import { LOAD_APPLICATIONS, CREATE_APPLICATION_REQUEST, REQUEST_DELETE_APPLICATION } from './constants'
import { setApplicationPage, setCreateApplicationLoading } from './actions'
import AppsClient from '../../apiClient/AppsClient'
import history from 'util/history'
import {signOut} from "../Admin/actions";

const appsClient = new AppsClient()

function* onLoadApplication(payload) {
    try {
        const { applications } = yield call(appsClient.load)
        yield put(setApplicationPage({ applications }))
    } catch (e) {
        yield put(signOut())
    }

}

function* createApplication({ payload: { name } }) {
    try {
        const { id } = yield call(appsClient.create, { name })
        yield put(setCreateApplicationLoading(false))
        history.push(`/${id}/dashboard`)
    } catch (e) {
        yield put(setCreateApplicationLoading(false))
        console.warn(e)
    }
}

function* deleteApplication () {
    try {
       const { application } = yield call(appsClient.deleteApplication)
        history.push(`/`)
    } catch (e) {
        console.warn(e)
    }
}

export default function* applicationsSagas() {
    yield all([
        takeEvery(LOAD_APPLICATIONS, onLoadApplication),
        takeEvery(CREATE_APPLICATION_REQUEST, createApplication),
        takeEvery(REQUEST_DELETE_APPLICATION, deleteApplication)
    ])
}
